import React, { useState, useEffect, useContext, useMemo } from "react";
import CancelIcon from "@mui/icons-material/Cancel";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ChatContacts from "./ChatContacts";
import ChatMessages from "./ChatMessages";
import ChatSendMessage from "./ChatSendMessage";

import CashierApi from "../../utility/CashierApi";
import { useQuery } from "@tanstack/react-query";
import { CustomerContext } from "../CashierHomepage";

const ChatPopup = ({ openMessage, setOpenMessage }) => {
  const { setTotalUnreadMessages } = useContext(CustomerContext);
  const { fetchOnlyData } = CashierApi();

  const [selectedContact, setSelectedContact] = useState(null);
  const [selectedContactName, setSelectedContactName] = useState(null);

  const { data, refetch } = useQuery({
    queryKey: ["cashierContacts"],
    keepPreviousData: true,
    retry: false,
    staleTime: 20 * 1000,
    refetchInterval: 30 * 1000,
    refetchOnMount: false,
    queryFn: () => fetchOnlyData("chats/contacts"),
  });

  const allUnread = useMemo(() => {
    const contacts = Array.isArray(data) ? data : data?.data;
    if (!Array.isArray(contacts)) return [];

    return contacts.map(
      (items) =>
        (items?.messages || []).filter(
          (item) => Number(item?.is_read) === 0 && item.role === "receiver"
        ).length
    );
  }, [data]);

  useEffect(() => {
    const sum = Array.isArray(allUnread)
      ? allUnread.reduce((acc, count) => acc + count, 0)
      : 0;

    setTotalUnreadMessages(sum);
  }, [allUnread, setTotalUnreadMessages]);

  const handleContactClick = (contactId, name) => {
    setSelectedContact(contactId);

    setSelectedContactName(name);
  };
  const handleClose = () => {
    setOpenMessage(false);
    setSelectedContact(null);
  };

  const handleRefetch = () => {
    setTimeout(() => {
      refetch();
    }, 2000);
  };

  return (
    openMessage && (
      <div className="pt-2 bg-gray-100 fixed bottom-4 right-2  w-full overflow-x-auto lg:w-[40rem] shadow-lg rounded-lg z-30  overflow-hidden">
        <div className="flex justify-end pr-2  border-b-2">
          <CancelIcon
            onClick={handleClose}
            className="cursor-pointer text-black mb-2"
          />
        </div>

        <div className=" flex h-[500px]">
          {/* Contact List */}
          <div className="w-2/5 bg-gray-100 py-4 px-2  border-r text-gray-800 border-gray-200 overflow-y-auto">
            <h2 className="font-bold mb-4 ">Contacts</h2>
            <ChatContacts handleContactClick={handleContactClick} data={data} />
          </div>

          {/* Chat Screen */}
          <div className="w-3/4 flex bg-white flex-col">
            <div className="p-4 border-b border-gray-200">
              <h2 className="font-bold text-gray-800">
                {selectedContactName ? (
                  <div>
                    {" "}
                    <AccountCircleIcon /> {selectedContactName}
                  </div>
                ) : (
                  "Select a contact"
                )}
              </h2>
            </div>
            <ChatMessages
              selectedContact={selectedContact}
              handleRefetch={handleRefetch}
            />
            <ChatSendMessage selectedContact={selectedContact} />
          </div>
        </div>
      </div>
    )
  );
};

export default React.memo(ChatPopup);
